import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import VueJwt from './plugins/jwt'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

import { DEBUG } from './config'
import filter from './utils/filter'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'


/**
* VueResource configuration
*/
Vue.use(VueResource)

/**
* Router Configuration
*/
Vue.use(VueRouter)

/**
* Vuex Configuration
*/
Vue.use(Vuex)

/**
* Vue jwt configuration
*/
Vue.use(VueJwt)

Vue.use(DatetimePlugin)

/**
* Register global filter
**/
Vue.filter('mapper', filter)

Raven.debug = DEBUG
if (!DEBUG) {
Raven.config('http://3b1d64375bbf46e482bec3c440bf13d9@120.77.87.127:9000/2')
.addPlugin(RavenVue, Vue)
.install()
}

export default Vue
export {
VueRouter,
VueResource,
Vuex,
}



// WEBPACK FOOTER //
// ./client/setup.js